import api from "../api/axios"

export const getTrainers = () => api.get("/trainers").then((r) => r.data)
export const createTrainer = (data) => api.post("/trainers", data).then((r) => r.data)
export const updateTrainer = (id, data) => api.put(`/trainers/${id}`, data).then((r) => r.data)
export const deleteTrainer = (id) => api.delete(`/trainers/${id}`).then((r) => r.data)
